import * as z from "zod/v4";

export const getGmailRecentMessages = {
  name: "getGmailRecentMessages" as const,
  input: z.object({ integrationId: z.string(), query: z.string().optional() }),
  output: z.object({
    messages: z.array(
      z.object({
        id: z.string(),
        threadId: z.string().optional(),
        subject: z.string().optional(),
        from: z.string().optional(),
        date: z.string().optional(),
        snippet: z.string().optional(),
      }),
    ),
  }),
};
